<template>
  <a-card :bordered="false">
    <a-row :gutter="20">
      <a-col :span="16">
        <patient-list listUrl="/management/empiPix/patientList" :exportEmpi="true" :baseParams="{projectIdSearch:'1'}" :search="true" :mini="true" @onselect="handleSelect"></patient-list>
      </a-col>
      <a-col :span="8">
        <empi-pix-list ref="pix-list"></empi-pix-list>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import PatientList from '@/views/project/patient/components/register/PatientList'
  import EmpiPixList from '@/views/management/empi/list/EmpiPixList'

  export default {
    name: "EmpiPix",
    mixins:[],
    components: {
      EmpiPixList,
      PatientList,
    },
    props:{
      empi:{
        type:String,
        default:''
      }
    },
    data () {
      return {
      }
    },
    computed: {
    },
    watch:{
    },
    mounted(){
    },
    methods: {
      handleSelect(record){
        const currentRecord = {
          empi:record.eid,
          projectPatientId:record.id,
          projectId:record.projectId,
          patientName:record.name,
          patientNum:record.patientNum,
        }
        this.$refs['pix-list'].loadDataByBaseInfo(currentRecord)
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>